import { ReactNode } from 'react';

/**
 * Компонент-обертка для рендера модулей. Сейчас провайдеров не добавляет.
 *
 * @param props - Параметры компонента
 * @returns Дочерние элементы без изменений
 */
export function ModulesProviders(props: { children: ReactNode }) {
    return <>{props.children}</>;
}
